var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalgar1Ny01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 77.5 67.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "-5.51 63.72 77.5 63.72 77.5 0 -5.51 0 -5.51 63.72"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 10.21,
    y1: 34.83,
    x2: 66.88,
    y2: 34.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 13.75,
    y1: 13.11,
    x2: 13.75,
    y2: 56.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 18.94,
    y1: 13.2,
    x2: 22.75,
    y2: 56.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 26.05,
    y1: 13.2,
    x2: 29.83,
    y2: 56.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.91,
    y1: 13.2,
    x2: 33.13,
    y2: 56.49
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "49.18 56.58 49.18 13.11 49.18 56.58"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 54.37,
    y1: 13.2,
    x2: 58.15,
    y2: 56.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 65.26,
    y1: 13.2,
    x2: 61.45,
    y2: 56.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 10.21,
    y1: 34.83,
    x2: 66.88,
    y2: 34.83
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalgar1Ny01);
export default __webpack_public_path__ + "static/media/galgar 1 ny-01.1da27585740882598c9c2cec88d5d0c4.svg";
export { ForwardRef as ReactComponent };